export default {
  type: 'directories',
  config: {
    relationships: {
      current_configuration: {
        type: 'directory_configurations'
      }
    }
  }
};
//# sourceMappingURL=directory.js.map